<div
  class="store-logo gap-micro"
  [ngClass]="{ 'surface-elevated': backgroundMode() === 'elevated', 'surface-back': backgroundMode() !== 'elevated' }"
  [style.borderRadius]="borderRadius()"
>
  <ui-api-image
    [width]="'100%'"
    [height]="'24px'"
    [borderRadius]="'24px'"
    [imageId]="logoImageId()"
    [fallbackImage]="'assets/fallback/digipay-logo-32x32-fallback.svg'"
  ></ui-api-image>
  @if (score()) {
    <ngx-badge
      [status]="'neutral'"
      [type]="'count'"
      [mode]="'fill'"
      [size]="'tiny'"
    >
      {{ score() }}
    </ngx-badge>
  }
</div>
